const COLUMN_CONFIG = {
  SAIA: "SAIA",
  DEFAULT: "DEFAULT",
};

const SHIPMENT_SELECTION_STEPS = {
  IB_BILLS: "IB_BILLS",
  RETURNS: "RETURNS"
};

const APP_DATE_FORMAT = "yyyy-MM-dd";

export { COLUMN_CONFIG, APP_DATE_FORMAT, SHIPMENT_SELECTION_STEPS };
